exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".k-header-download-btn .v-progress-circular{height:16px !important;width:16px !important}.k-header-download-btn .v-icon{line-height:18px;font-size:18px !important;margin-bottom:-2px}.k-filter-menu-item .k-download-progress{margin-left:16px;opacity:0}.k-filter-menu-item.active .k-download-progress{opacity:1}\n", ""]);

// exports
